<template>

<!-- NAV BAR ------------------------------------------------>
<div class="container-fluid">
    <div class="row">
        <nav class="col-12 navbar navbar-expand-lg navbar-light bg-light d-flex">
            <a class="navbar-brand ms-3" href="#">Personal Portfolio</a>

            <!-- Toggler button for mobile -->
            <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Navbar Links -->
            <div class="collapse navbar-collapse" id="navbarContent">
                <ul class="navbar-nav ms-auto d-flex flex-row gap-3">
                    <li class="nav-item"><a class="nav-link" href="#Intro">Intro</a></li>
                    <li class="nav-item"><a class="nav-link" href="#Tooling">Tooling</a></li>
                    <li class="nav-item"><a class="nav-link" href="#Projects">Projects</a></li>
                    <li class="nav-item"><a class="nav-link" href="#Certifications">Certifications</a></li>
                    <li class="nav-item"><a class="nav-link" href="https://wa.me/+923048422800">Contact</a></li>
                </ul>
            </div>
        </nav>
    </div>
</div>

  <!-- Main info , Intro page --------------------------------------------------------->
  <div id="Intro" class="container" style="margin-top: 20vh;">
    <div class="row">
      <div class="col-lg-5 d-flex justify-content-center align-items-center"><img class="img-fluid w-75 rounded-5" src="./assets/photo.jpeg" alt=""></div>
      <div class="col-lg-7 d-inline-flex flex-row justify-content-between align-items-center mt-2 gap-2 neon-text">
        <section class="text-center">
          <h1 class="text-light">Mir Shah Mir</h1>
          <br>
          <h1 class="text-light" style="font-size: 20px; font-weight: 200;">Electrical Engineer & Web Designer</h1>
          <br>
          <h5 class="fst-italic text-light" style="text-align: justify;">Hi!, I am a passionate Electrical Engineer & Web Designer,
            who builds across hardware and software. I enjoy turning ideas into reality,  
            I hold a Bachelors of Science Degree in Electrical Engineering. I'm always open to new opportunities where I
            can combine engineering and thoughtful design.
          </h5>
          <br>
          <a href="/cv.pdf" download>
            <button class="btn download-btn rounded border text-light" type="button">Download Resume</button>
          </a>
        </section>
      </div>
    </div>
  </div>

  <!-- TOOLING ---------------------------------------------------->
  <div id="Tooling" class="container" style="margin-top: 15vh;">

    <div class="row text-center text-light">
      <div class="col">
        <h1>Tooling</h1>
      </div>
    </div>
    <br>
    <div class="row text-light text-center gy-4 mt-5"> 
      <div v-for="(tool, index) in tools" :key="index" class="col-md-3 d-flex justify-content-center align-items-center">
        <div class="tool-card p-3 text-center border rounded h-100 w-75 d-flex flex-column align-items-center justify-content-center">
          <img :src="tool.image" :alt="tool.name" class="img-fluid mb-2" style="width: 6vw;">
          <h5>{{ tool.name }}</h5>
        </div>
      </div>
    </div>
  </div>


  <!-- Projects ---------------------------------------------------------------->
  <div id="Projects" class="container text-light" style="margin-top: 20vh;">

  <div class="row text-center">
    <div class="col">
      <h1>Projects</h1>
    </div>
  </div>

  <!-- Project 1 , Quick Fix ------------------->
  <div class="row" style="margin-top: 20vh;">
    <div class="col">
      <section>
        <h3>Project Name: <span style="font-weight: 100;">Quick Fix</span></h3>
        <h3>Description: <span style="font-weight: 100;">A Platform that connects car owners with mechanics</span></h3>
        <h3>Application Type: <span style="font-weight: 100;">Mobile ( Android ) ( Apple coming soon )</span></h3>
        <h3>Tech Stacks : <span style="font-weight: 100;">Nodejs, Expressjs, Mongodb, TS, Vuejs, Capacitor</span></h3>
        <h3>Status: <span style="color: #008000 ;">Live</span></h3>
        <h3>Download Apk <span><a href="https://mega.nz/file/WugVHT5C#4O98hNioLy2uELR4bT91TKW6mUFXtTOopOFQ2mL-yYw" target="_blank">Here!</a></span></h3>
      </section>
    </div>
  </div>

<!-- Project 1 Mockups --------------------------->
  <div class="row mt-5 neon-text">

    <div class="col-lg-3 d-flex justify-content-center align-items-center">
      <img class="img-fluid " src="https://lmeiyut99gyw3i3z.public.blob.vercel-storage.com/started-UsOM0EwsEEpGmCUO1f2dkaLW6ojpEX.png" alt="">
    </div>

    <div class="col-lg-3 d-flex justify-content-center align-items-center">
      <img class="img-fluid w-75" src="https://lmeiyut99gyw3i3z.public.blob.vercel-storage.com/home-dGLWWvw52XO3xXfhYVSNwptMqkJoUQ.png" alt="">
    </div>

    <div class="col-lg-3 d-flex justify-content-center align-items-center">
      <img class="img-fluid" src="https://lmeiyut99gyw3i3z.public.blob.vercel-storage.com/find-75y4DyarwECDsRf8JE8gd94340nDt2.png" alt="">
    </div>

    <div class="col-lg-3 d-flex justify-content-center align-items-center">
      <img class="img-fluid w-75" src="https://lmeiyut99gyw3i3z.public.blob.vercel-storage.com/loc-pljGiZejuiHqIZmqpdH27PZkjrc2Fr.png" alt="">
    </div>
  </div>


  <!-- Project 2 , Quick Fix ------------------->
  <div class="row" style="margin-top: 20vh;">
    <div class="col">
      <section>
        <h3>Project Name: <span style="font-weight: 100;">Feast Fly</span></h3>
        <h3>Description: <span style="font-weight: 100;">A Website for resturant owners to increase their sales</span></h3>
        <h3>Application Type: <span style="font-weight: 100;">Web ( All Devices )</span></h3>
        <h3>Tech Stacks : <span style="font-weight: 100;">TS, Vuejs, Emailjs</span></h3>
        <h3>Status: <span style="color: #008000 ;">Live</span></h3>
        <h3>Visit Here <span><a href="https://feast-fly-rosy.vercel.app/" target="_blank">Here!</a></span></h3>
      </section>
    </div>
  </div>


  <!-- Project 2 Mockups -------------->
  <div class="row text-center mt-5 neon-blue">
    <div class="col">
      <img class="img-fluid rounded" src="./assets/feast_mockups/1.png" alt="">
    </div>
  </div>

  <div class="row text-center mt-5">
    <div class="col-8">
      <img class="img-fluid rounded" src="./assets/feast_mockups/2.png" alt="">
    </div>
    <div class="col-4 mt-lg-5">
      <img class="img-fluid rounded" src="./assets/feast_mockups/3.png" alt="">
    </div>
  </div>


  </div>

  <div id="Certifications" class="container text-light" style="margin-top: 15vh; margin-bottom: 15vh;">
    <div class="row text-center">
      <div class="col">
        <h1>Certifications</h1>
      </div>
    </div>

    <div class="row mt-5 gy-4 justify-content-center">
      <div v-for="(cert, index) in certifications" :key="index" class="col-md-3 col-6 d-flex justify-content-center align-items-center">
        <div class="cert-card">
          <a :href="cert.image" target="_blank" rel="noopener noreferrer">
            <img :src="cert.image" :alt="cert.name" class="cert-img img-fluid rounded">
          </a>
        </div>
      </div>
    </div>
  </div>

  <footer class="bg-dark text-light text-center py-3 mt-5">
    <div class="container">
      <p class="mb-2">&copy; 2025. All rights reserved.</p>
      <small>Portfolio Design by Mir Shahmir</small>
      <br>
      <div>
        <a href="https://github.com/Ak47-Smoke" class="text-light mx-2"><i class="fab fa-2x fa-github"></i></a>
        <a href="https://www.linkedin.com/in/mir-shahmir-28a625328/" class="text-light mx-2"><i class="fab fa-2x fa-linkedin"></i></a>
        <a href="https://wa.me/+923048422800" class="text-light mx-2"><i class="fab fa-2x fa-whatsapp"></i></a>
      </div>
    </div>
  </footer>

</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';


@Options({
  components: {
   
  },
})
export default class App extends Vue {
  
  tools: { name: string; image: string }[] = [
    { name: 'Nodejs', image: require('./assets/nodejs.png') },
    { name: 'Javascript', image: require('./assets/js.png') },
    { name: 'Typescript', image: require('./assets/ts.png') },
    { name: 'Mongodb', image: require('./assets/mongodb.png')},
    { name: 'Vuejs', image: require('./assets/logo.png') },
    { name: 'Html', image: require('./assets/html.png') },
    { name: 'Css', image: require('./assets/css.png')},
    { name: "Bootstrap", image: require('./assets/bootstrap.png') }
  ];

  certifications: { name: string; image: string }[] = [
    { name: 'Certification 1', image: require('./assets/certs/js.jpg') },
    { name: 'Certification 2', image: require('./assets/certs/ts.jpg') },
    { name: 'Certification 3', image: require('./assets/certs/inter-ts.jpg') },
    { name: 'Certification 4', image: require('./assets/certs/vuejs.jpg') }
  ];

}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');


.montserrat {
  font-family: "Montserrat", serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

html {
    scroll-behavior: smooth;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Montserrat", serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}
body {
  background: #000000;  /* fallback for old browsers */
}

.download-btn:hover {
  background-color: rgba(255, 20, 145, 0.212);
}


.neon-text {
  position: relative; /* Keeps it in place */
  color: white; /* Text color */
}

.neon-text::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(255, 20, 147, 0.6) 10%, rgba(255, 20, 147, 0) 100%);
  filter: blur(50px);
  z-index: -1; /* Pushes glow behind the text */
  opacity: 1; /* Adjust brightness */
}

@keyframes neonPulse {
  0% { opacity: 0.6; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 0.9; transform: translate(-50%, -50%) scale(1.1); }
  100% { opacity: 0.6; transform: translate(-50%, -50%) scale(1); }
}

.neon-text::before {
  animation: neonPulse 3s infinite alternate;
}


.neon-blue {
  position: relative; /* Keeps it in place */
  color: white; /* Text color */
}

.neon-blue::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: radial-gradient(circle, rgba(20, 184, 255, 0.6) 10%, rgba(255, 20, 147, 0) 100%);
  filter: blur(50px);
  z-index: -1; /* Pushes glow behind the text */
  opacity: 1; /* Adjust brightness */
}

.neon-blue::before {
  animation: neonPulse 3s infinite alternate;
}




/* Navbar */
.cert-card {
  border-radius: 12px;
  /* removed overflow: hidden */
}

.cert-img {
  width: 100%;
  border-radius: 12px;
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  cursor: pointer;
  position: relative;
}

.cert-img:hover {
  transform: scale(1.4);
  box-shadow: 0 0 25px rgba(255, 20, 147, 0.5);
  z-index: 10;
}




.tool-card {
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  cursor: pointer;
}

.tool-card:hover {
  transform: scale(1.25);
  box-shadow: 0 0 25px rgba(255, 255, 255, 0.5);
  z-index: 10;
  position: relative;
}
</style>
